import { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import { actionTypes } from 'actions/actionTypes'
import * as trackingKeys from 'actions/trackingKeys'
import { useRecipesImmutable } from 'hooks/menu-recipes/useRecipes'
import { Recipe, RecipeUUID } from 'reducers/menu-recipes/recipes'

export const useTrackSoldOutRecipesEffect = (ids: (RecipeUUID | null)[]) => {
  const recipes = useRecipesImmutable(ids)

  const dispatch = useDispatch()

  useEffect(() => {
    const soldOutRecipes = recipes
      .filter((recipe): recipe is Recipe => recipe !== null)
      .filter((recipe: Recipe) => !recipe.isAvailable)
      .map((recipe: Recipe) => recipe.coreId)

    if (!soldOutRecipes?.length) return

    dispatch({
      type: actionTypes.TRACKING,
      trackingData: {
        actionType: trackingKeys.soldOutRecipes,
        soldOutRecipes,
      },
    })
  }, [recipes, dispatch])
}
